export default __webpack_public_path__ + "static/media/roadmap-m-3.68a794b9.png";